// ----------20230302----------- //
// 分类列表
export function getCategoryNew (data) {
  return this.fetch({
    method: 'POST',
    platformCode: true,
    url: 'mall-server/api/category/v1/categoryList',
    data
  })
}
// 分类列表下的商品列表
export function getGoodsDtoList (data) {
  return this.fetch({
    url: 'mall-server/api/goods/v1/goodsList',
    method: 'POST',
    data
  })
}

// 商品详情
export function getGoodsDetails (params) {
  return this.fetch({
    method: 'GET',
    url: 'mall-server/api/goods/v1/getDetailInfo',
    params
  })
}
// 获取商品优惠券列表
export function getGoodsBonus (params) {
  return this.fetch({
    url: 'mall-server/api/act/v2/getGoodsBonus',
    method: 'GET',
    params
  })
}
// 获取商品规格数据
export function getGoodsModels (params) {
  return this.fetch({
    url: 'mall-server/api/goods/v1/goods-models',
    method: 'get',
    params
  })
}
// 购物车列表
export function getCartListNew (data) {
  return this.fetch({
    method: 'GET',
    url: 'mall-server/api/cart/v1/list',
    data
  })
}
// 点击加入购物车
export function inputCartNew (data) {
  return this.fetch({
    method: 'POST',
    url: 'mall-server/api/cart/v1/addGoods',
    data
  })
}
// 更新购物车数量
export function updateGoodsNumNew (data) {
  return this.fetch({
    method: 'POST',
    url: 'mall-server/api/cart/v1/updateGoodsNum',
    data
  })
}

// 删除购物车商品
export function deleteGoodsNew (data) {
  return this.fetch({
    method: 'POST',
    url: 'mall-server/api/cart/v1/delGoods',
    data
  })
}
// 勾选&取消勾选购物车商品
export function updateGoodsSelectNew (data) {
  return this.fetch({
    platformCode: true,
    method: 'POST',
    url: 'mall-server/api/cart/v1/updateGoodsSelect',
    data
  })
}

// 获取店铺/商品不发货地区列表
export function getNonsupportShippingAreas (params) {
  return this.fetch({
    url: 'mall-server/api/goods/v1/nonsupportShippingAreas',
    method: 'GET',
    params
  })
}

// 查询快递信息
export function getkdInfo (params) {
  return this.fetch({
    url: 'mall-server/api/kd/v1/query',
    method: 'GET',
    params
  })
}
